var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('svg',{attrs:{"data-src":`${_vm.$store.getters.bucket}${_vm.config.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }